import { SecretaryRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * secretaryOnSaveData - Function that saves on database a new secretary   
 * /secretaries  
 * method POST  
 * @async-function
 */
const secretaryOnSaveData = async (token: string, model: SecretaryRequestType) => {
    const response = await api.post(
        `/secretaries`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default secretaryOnSaveData;